import { useCallback } from "react";
import useFeature from "hooks/useFeature";
import useRightSidebar from "hooks/useRightSidebar";
import { useModalContext } from "common/contexts";
const MISSING_MODAL_PROVIDER_ERROR = "useModalContext must be used within a ModalProvider";
function useAssetPanel() {
  var _a, _b, _c;
  const isRightSidebarEnabled = useFeature("asset_right_sidebar");
  const { openSidebar, closeSidebar, content } = useRightSidebar();
  const modalContext = useModalContext(false);
  const selectedAssetId = isRightSidebarEnabled ? (_a = content == null ? void 0 : content.props) == null ? void 0 : _a.assetId : (_c = (_b = modalContext == null ? void 0 : modalContext.entity) == null ? void 0 : _b.asset) == null ? void 0 : _c.id;
  const openAssetDetails = useCallback(
    (asset) => {
      if (isRightSidebarEnabled) {
        openSidebar({
          id: `asset-${asset.id}`,
          title: "Asset Details",
          componentKey: "AssetSidebarContent",
          props: { assetId: asset.id }
        });
      } else {
        if (!modalContext) {
          throw new Error(MISSING_MODAL_PROVIDER_ERROR);
        }
        modalContext.setEntity({ asset });
        modalContext.setModal("ASSET-DETAILS");
      }
    },
    [isRightSidebarEnabled, openSidebar, modalContext]
  );
  const closeAssetDetails = useCallback(() => {
    if (isRightSidebarEnabled) {
      closeSidebar();
    } else {
      if (!modalContext) {
        throw new Error(MISSING_MODAL_PROVIDER_ERROR);
      }
      modalContext.setModal(null);
      modalContext.setEntity(null);
    }
  }, [isRightSidebarEnabled, closeSidebar, modalContext]);
  return {
    selectedAssetId,
    openAssetDetails,
    closeAssetDetails
  };
}
export default useAssetPanel;
